/**
 * What a bug report says — the reporter's two answers, kept as one description.
 *
 * HQ-BUG-INTAKE-002. Workflow map, Issue report to verified resolution, step 1:
 * "record reporter, affected app and page, clear description, expected result,
 * severity ...". The form took a description and nothing about what the reporter
 * expected, and the commonest reason a report cannot be reproduced is that nobody
 * can tell what "wrong" meant — the thing on screen may have been exactly right
 * to whoever built it.
 *
 * The expected result lives inside `description`, under a fixed heading, rather
 * than in a column of its own: hq_bug_reports has no such column, adding one is a
 * hand-applied migration, and everything that already reads `description` — the
 * admin list, the notification email, Cole's brief — picks it up for free.
 */
export const EXPECTED_HEADING = "What I expected:";

export function composeBugDescription(whatHappened: string, expected: string): string {
  const what = whatHappened.trim();
  const exp = expected.trim();
  return exp ? `${what}\n\n${EXPECTED_HEADING} ${exp}` : what;
}

/** Reads a composed description back apart, for showing the two parts apart. */
export function splitBugDescription(description: string): { what: string; expected: string | null } {
  const at = description.lastIndexOf(`\n\n${EXPECTED_HEADING} `);
  if (at < 0) return { what: description, expected: null };
  return {
    what: description.slice(0, at),
    expected: description.slice(at + 2 + EXPECTED_HEADING.length + 1).trim() || null,
  };
}
